import { Grid, Container, Typography, useTheme, Box } from "@mui/material"
import { OtByLocationState } from "../components/otbylocationstate"
import TechnicalMetrics from "../components/technicalMetrics"
import OtByLocationsMetrics from "../components/otbyLocationsMetrics"
import SelectedLocation from "../components/selectedLocation"
import TaskScheduledPerMonthMetrics from "../components/TaskScheduledPerMonthMetrics"
import TaskNotScheduledPerMonthMetrics from "../components/TaskNotScheduledPerMonthMetrics"
import OtScheduledByState from "../components/OtScheduledByState"


export default function DashView({ otMetricsByLocation }) {
  const theme = useTheme();

  return (
    <Container maxWidth="xl">
      <Grid container spacing={4} columns={12}>

        <Grid item size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
          <SelectedLocation otMetricsByLocation={otMetricsByLocation} />
        </Grid>
        <Grid item size={{ xs: 12 }}>
          <Typography variant="h6" sx={{
            fontWeight: 'bold',
            fontSize: { xs: '1rem', sm: '1.2rem' },
            color: theme.palette.text.primary,
            textAlign: 'left',
            lineHeight: 1
          }}>MANTENIMIENTO CORRECTIVO</Typography>
        </Grid>
        <Grid item size={{ xs: 12, md: 6 }}>
          <OtByLocationState />
          <Box sx={{ mt: 4 }}>
            <TechnicalMetrics />
          </Box>
        </Grid>
        <Grid item size={{ xs: 12, md: 6 }}>
          <TaskNotScheduledPerMonthMetrics />

        </Grid>
        <Grid item size={{ xs: 12, md: 6 }}>

        </Grid>
        <Grid item size={{ xs: 12 }}>
          <Typography variant="h6" sx={{
            fontWeight: 'bold',
            fontSize: { xs: '1rem', sm: '1.2rem' },
            color: theme.palette.text.primary,
            textAlign: 'left',
            lineHeight: 1
          }}>MANTENIMIENTO PREVENTIVO</Typography>
        </Grid>
        <Grid item size={{ xs: 12, md: 6 }}>
          <TaskScheduledPerMonthMetrics />
        </Grid>
        <Grid item size={{ xs: 12, md: 6 }}>
          <OtScheduledByState />
        </Grid>
      </Grid>
    </Container>
  )
}